export default __webpack_public_path__ + "static/media/img_slide_03.0bf8148c.jpg";